import { $workspaceMembers } from "./states";
import { fetchWorkspaceMembers } from "./effects";

// Workspace member list
$workspaceMembers.on(
    fetchWorkspaceMembers.doneData,
    (_, data) => data,
);
